<template lang="pug">
    .component-reveal-pay
        reveal(v-if="invoice.status !== 'PAID'", :confirm="true", @confirm="payInvoice")
            button.button.success(v-if="buttons", slot="trigger") Pay
            a(v-else, slot="trigger") Pay via gateway
            h2 Do you really want to pay the invoice
                strong INV{{invoice.internal_id}}({{invoice.id}})
</template>
<script type="text/babel">
    import Reveal from "../../Reveal";
    export default{
        name: "InvoiceRevealPay",
        components: {Reveal},
        data(){
            return {}
        },
        created() {
        },
        methods: {
            payInvoice(){
                this.$emit('payInvoice')
            }
        },
        computed: {},
        props: ['buttons', 'invoice'],
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// InvoiceRevealPay.vue?587d90b5